/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { deletionModeDescriptorSchema } from './deletionModeDescriptorSchema';
import { pushCapabilitySchema } from './pushCapabilitySchema';
import { rankingDetailsSchema } from './rankingDetailsSchema';

export const capabilityDescriptorSchema = z.object({
  changedSinceMode: z.enum([
    'SERVER_TIMESTAMP',
    'SERVER_COARSE',
    'CLIENT_HEURISTIC',
    'NONE',
    'UNSPECIFIED',
  ]),
  get deletionMode() {
    return deletionModeDescriptorSchema;
  },
  get push() {
    return pushCapabilitySchema;
  },
  ranking: z.boolean(),
  get rankingDetails() {
    return z.union([rankingDetailsSchema, z.null()]).optional();
  },
});
